import React from 'react';
import { PurposeKpiTermLike, purposeKpiScopeSentence } from './purposeKpiMask.utils';

/**
 * The one line a screen shows when the purpose in view measures less than the screen can render.
 *
 * Without it a reader who knows the product meets a page that has quietly lost its share-of-voice
 * card and reads the absence as a fault. One sentence naming what the purpose DOES measure answers
 * that before it is asked, and stays out of the way otherwise: it renders nothing at all for an
 * untyped tag (that page carries its own notice) or for a purpose that suppresses nothing.
 */
export function PurposeKpiScopeNote({ term, className }: { term: PurposeKpiTermLike | undefined; className?: string }) {
  const sentence = purposeKpiScopeSentence(term);
  if (!sentence) {
    return null;
  }

  return <p className={['text-sm text-slate-500 mb-0', className].filter(Boolean).join(' ')}>{sentence}</p>;
}
